import React, { FC, useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'

import { Skeleton } from '../../../components/ui/skeleton'

import { ITotals } from './ManageClinicNOtherAdminTabNew'

interface TotalRowProps {
  title: string
  total: number
  scratched: number
}

const TotalRow: FC<TotalRowProps> = ({ title, total, scratched }) => {
  return (
    <div className="min-w-fit w-full text-base py-6 flex items-center border-b border-b-SeabiscuitLightThemeColorD3">
      <p className="w-full min-w-[120px] pr-4">{title}</p>
      <p className="w-full min-w-[100px] max-w-[150px] text-right pl-4">{total}</p>
      <p className="w-full min-w-[100px] max-w-[150px] text-right pl-4">{scratched}</p>
      <p className="w-full font-bold min-w-[100px] max-w-[150px] text-right pl-4">
        {total - scratched}
      </p>
    </div>
  )
}

export const LoadingRow = () => {
  return (
    <div className="py-6 min-w-fit w-full flex items-center border-b border-b-SeabiscuitLightThemeColorD3">
      <div className="pr-4 w-full min-w-[120px]">
        <Skeleton className="h-6 w-[120px]" />
      </div>
      <div className="pl-4 ml-auto w-full min-w-[100px] max-w-[150px]">
        <Skeleton className="h-6 w-full" />
      </div>
      <div className="pl-4 w-full min-w-[100px] max-w-[150px]">
        <Skeleton className="h-6 w-full" />
      </div>
      <div className="pl-4 w-full min-w-[100px] max-w-[150px]">
        <Skeleton className="h-6 w-full" />
      </div>
    </div>
  )
}

interface ManageTotalsProps {
  getTotals: () => Promise<void>
  totals: ITotals
}

export const ManageTotals: FC<ManageTotalsProps> = ({ getTotals, totals }) => {
  const { eventId } = useParams<{ eventId: string }>()

  const [loading, setLoading] = useState(false)

  useEffect(() => {
    const getData = async () => {
      setLoading(true)
      await getTotals().then()
      setLoading(false)
    }
    getData().then()
  }, [eventId])

  return (
    <div className="overflow-auto pb-14">
      <div className="flex flex-col px-4 min-w-[340px]">
        <div className="min-w-fit w-full text-xs py-1 flex items-center border-b border-b-SeabiscuitLightThemeColorD3">
          <p className="w-full min-w-[120px]">Item</p>
          <p className="w-full min-w-[100px] max-w-[150px] text-right">Total</p>
          <p className="w-full min-w-[100px] max-w-[150px] text-right">Scratched</p>
          <p className="w-full min-w-[100px] max-w-[150px] text-right">Remaining</p>
        </div>
        {loading ? (
          Array.from({ length: 8 }).map((_, i) => <LoadingRow key={i} />)
        ) : (
          <>
            <TotalRow
              title="Entries"
              total={totals.entries.total}
              scratched={totals.entries.scratched}
            />
            <TotalRow
              title="Riders"
              total={totals.riders.total}
              scratched={totals.riders.scratched}
            />
            <TotalRow
              title="Horses"
              total={totals.horses.total}
              scratched={totals.horses.scratched}
            />
            <TotalRow
              title="Registrars"
              total={totals.registrars.total}
              scratched={totals.registrars.scratched}
            />
            <TotalRow
              title="Guardians"
              total={totals.guardians.total}
              scratched={totals.guardians.scratched}
            />
            <TotalRow
              title="Minors"
              total={totals.minors.total}
              scratched={totals.minors.scratched}
            />
            <TotalRow
              title="Trainers"
              total={totals.trainers.total}
              scratched={totals.trainers.scratched}
            />
            <TotalRow
              title="Owners"
              total={totals.owners.total}
              scratched={totals.owners.scratched}
            />
          </>
        )}
      </div>
    </div>
  )
}
